module.exports = __webpack_public_path__ + "assets/Manufacturing.91eb832e.svg";